import { Box, CircularProgress, IconButton, TextField } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import {
  actionIconsBox,
  imageBoxStyles,
  imageUploadButton,
  profileImageContainer,
} from './styles';
import { GREEN_COLOR, RED_COLOR } from '../../styles/constants';
import { enqueueSnackbar } from 'notistack';
import { UploadImage } from '../../DAL/Books/books';

export function ImageUploader({
  imageUrl,
  callBackResponse,
  name,
  returnValue,
}) {
  
  const fileInputRef = useRef(null);
  const [fileDataUrl, setFileDataUrl] = useState(null);
  const [currentFile, setCurrentFile] = useState(null);
  const [displayActions, setDisplayActions] = useState(false);
  const [isImageUploading, setIsImageUploading] = useState(false)
  // useEffect(() => {
  //   if (callBackResponse && name) {
  //     if (returnValue) {
  //       callBackResponse(fileDataUrl);
  //     } else {
  //       const response = {
  //         ...currentFile,
  //         target: { value: fileDataUrl, name },
  //       };
  //       callBackResponse(response);
  //     }
  //     setDisplayActions(false);
  //   }
  // }, [fileDataUrl, returnValue, name]);


const handleImageChange = async event => {
  try {
    setIsImageUploading(true);

    const file = event?.target?.files?.[0];
    if (!file) {
      enqueueSnackbar("No file selected", { variant: "warning" });
      setIsImageUploading(false);
      return;
    }

    setCurrentFile(file);

    const response = await UploadImage(file);
    if (response.status === 200) {
      setFileDataUrl(response?.data?.Location);
      callBackResponse({target: { value: response?.data?.Location, name }})
      setDisplayActions(true);
    } else {
      const errorMessage =
        typeof response.message === "string"
          ? response.message
          : "Invalid credentials";

      enqueueSnackbar(errorMessage, { variant: "error" });
    }
  } catch (error) {
    enqueueSnackbar("Something went wrong while uploading the image", {
      variant: "error",
    });
  } finally {
    setIsImageUploading(false);
  }
};


  const resetValues = () => {
    setDisplayActions(false);
    setFileDataUrl(null);
    setCurrentFile(null);
  };

  return (
    <>
    <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
  <Box
    sx={{
      width: 120,
      height: 120,
      borderRadius: '50%',
      overflow: 'hidden',
      border: '2px dashed #ccc',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      cursor: 'pointer',
      backgroundColor: '#f5f5f5',
    }}
    onClick={() => !isImageUploading && fileInputRef.current.click()}
  >
    {isImageUploading ? (
      <CircularProgress size={24} />
    ) : fileDataUrl || imageUrl ? (
      <img
        src={fileDataUrl || imageUrl}
        alt="Cover"
        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
      />
    ) : (
      <PhotoCameraIcon sx={{ fontSize: 32, color: '#888' }} />
    )}
    <TextField
      inputRef={fileInputRef}
      type="file"
      name={name}
      sx={{ display: 'none' }}
      onChange={handleImageChange}
    />
  </Box>
</Box>

      {/* <Box component='div' sx={imageBoxStyles}>
        <Box
          component='div'
          sx={profileImageContainer(fileDataUrl || imageUrl || null)}
        >
          <TextField
            inputRef={fileInputRef}
            type='file'
            name={name}
            sx={{ display: 'none' }}
            onChange={handleImageChange}
          />
          <IconButton
            sx={imageUploadButton}
            onClick={() => !isImageUploading && fileInputRef.current.click()}
          >
            {isImageUploading ? (
              <CircularProgress color='inherit' size={16} />
            ) : (
              <PhotoCameraIcon sx={{ fontSize: '1rem' }} />
            )}
          </IconButton>
        </Box>
      </Box> */}
      {/* {displayActions && (
        <Box component='div' sx={actionIconsBox}>
          <IconButton onClick={resetValues}>
            <CloseIcon sx={{ fontSize: '1.5rem', color: RED_COLOR.DARK }} />
          </IconButton>
          <IconButton onClick={() => imageUploadHandler(currentFile)}>
            <DoneIcon sx={{ fontSize: '1.5rem', color: GREEN_COLOR.BRIGHT }} />
          </IconButton>
        </Box>
      )} */}
    </>
  );
}
